function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="20 0 62 62" fill="none" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M37.865 21.904c-.805-.161-1.893-.282-2.576-.282-1.852 0-1.973.806-1.973 2.094v2.293h4.63l-.404 4.75h-4.226v14.45H27.52v-14.45h-2.979v-4.75h2.98v-2.938c0-4.025 1.891-6.28 6.64-6.28 1.65 0 2.858.242 4.428.564l-.724 4.549z" fill="#4B2118" /></svg>;
});